module.exports = __webpack_public_path__ + "img/ox.49960ab3.jpg";